import styled from "styled-components";

export const HeaderDiv = styled.header`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: var(--outerMargin);
  border-bottom: var(--border);
  & h1 {
    margin: 0;
    a {
      color: var(--text);
    }
  }
`;
